import React from 'react';
import './index.less';
import ToolBar from '../ToolBar';

const DetailLayout = (props: any) => {
  const { detail, opers, children } = props;

  const prefixClx = 'bidding-detail-layout';

  const toolbarProps = {
    title: detail.name,
    stateName: detail.human_state_name,
    productCode: detail.product_identifier,
    demandUser: detail.author_name,
    id: detail.id,
  };

  return (
    <div className={prefixClx}>
      <ToolBar {...toolbarProps}>{opers}</ToolBar>
      <div className={`${prefixClx}-content`}>{children}</div>
    </div>
  );
};

export default DetailLayout;
